import React, { Component } from 'react';

//componentes
import AdjuntarNotas from './subirArchivosPlani'

class Index extends Component {

    render(){
        return(
            <div>
                <AdjuntarNotas />
            </div>
        );
    }

}
export default Index;